import React from "react";
import { Box, Container, Grid, Typography } from "@mui/material";
import AnimatedSection from "../common/AnimatedSection";
import SectionHeading from "../common/SectionHeading";

const NAVY = "#1B1F3B"; const CORAL = "#FF6B6B"; const YELLOW = "#FFD93D"; const TEAL = "#06D6A0"; const PURPLE = "#845EF7"; const ORANGE = "#FF9F1C";

const FAC_ICONS = ["🏫", "📚", "🔬", "🎨"];
const FAC_COLORS = [TEAL, CORAL, PURPLE, ORANGE];
const SPORTS_ICONS = ["⚽", "🏆", "🎭"];
const SPORTS_COLORS = [CORAL, YELLOW, TEAL];

const FacilitiesSection = ({ facilities, sports }) => (
  <AnimatedSection id="facilities" sx={{ backgroundColor: "#FFF8F0", py: { xs: 9, md: 12 } }}>
    <Container maxWidth="xl">
      <SectionHeading
        eyebrow="Campus Life"
        title="A Happy Place to Learn and Grow 🏫"
        description="A safe, welcoming campus with spaces for learning, play, creativity and activities that help students grow every day."
        eyebrowColor={CORAL}
        eyebrowBg="#FFE8E8"
      />

      {/* Facility cards */}
      <Grid container spacing={3} sx={{ mb: 6 }}>
        {facilities.map((f, i) => (
          <Grid item xs={12} sm={6} md={3} key={i}>
            <Box
              sx={{
                p: 3, height: "100%",
                borderRadius: "16px",
                border: `2.5px solid ${NAVY}`,
                backgroundColor: "#fff",
                boxShadow: `5px 5px 0 ${NAVY}`,
                transition: "all 0.2s ease",
                "&:hover": { transform: "translate(-3px,-3px)", boxShadow: `8px 8px 0 ${NAVY}` },
              }}
            >
              <Box sx={{ width: 56, height: 56, borderRadius: "14px", backgroundColor: FAC_COLORS[i], border: `2px solid ${NAVY}`, display: "grid", placeItems: "center", fontSize: "1.6rem", mb: 2, animation: `bounce ${2 + i * 0.4}s ease-in-out infinite` }}>
                {FAC_ICONS[i]}
              </Box>
              <Typography variant="h5" sx={{ fontFamily: "'Fredoka One', cursive", fontSize: "1.15rem", color: NAVY, mb: 1 }}>
                {f.title}
              </Typography>
              <Typography sx={{ color: "#4A4E6D", fontWeight: 600, lineHeight: 1.7, fontSize: "0.9rem" }}>
                {f.description}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>

      {/* Sports divider */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 4 }}>
        <Box sx={{ flex: 1, height: "3px", backgroundColor: NAVY, borderRadius: 2 }} />
        <Typography sx={{ fontFamily: "'Fredoka One', cursive", fontSize: "1.4rem", color: NAVY, whiteSpace: "nowrap" }}>
          Sports & Co-curricular 🏃
        </Typography>
        <Box sx={{ flex: 1, height: "3px", backgroundColor: NAVY, borderRadius: 2 }} />
      </Box>

      {/* Sports cards */}
      <Grid container spacing={3}>
        {sports.map((s, i) => (
          <Grid item xs={12} sm={4} key={i}>
            <Box
              sx={{
                p: 3, height: "100%",
                borderRadius: "16px",
                border: `2.5px solid ${NAVY}`,
                backgroundColor: SPORTS_COLORS[i],
                boxShadow: `5px 5px 0 ${NAVY}`,
                transition: "all 0.2s ease",
                "&:hover": { transform: "translate(-3px,-3px)", boxShadow: `8px 8px 0 ${NAVY}` },
              }}
            >
              <Typography sx={{ fontSize: "2.2rem", mb: 1.5, display: "block", animation: `wiggle ${2 + i * 0.5}s ease-in-out infinite` }}>
                {SPORTS_ICONS[i]}
              </Typography>
              <Typography variant="h5" sx={{ fontFamily: "'Fredoka One', cursive", fontSize: "1.15rem", color: NAVY, mb: 1 }}>
                {s.title}
              </Typography>
              <Typography sx={{ color: NAVY, fontWeight: 700, opacity: 0.75, lineHeight: 1.7, fontSize: "0.9rem" }}>
                {s.description}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Container>
  </AnimatedSection>
);

export default FacilitiesSection;
